import { Injectable, Inject } from '@angular/core';
import { KursService } from "./kurs.service";
import { Kursteilnehmer } from "./../_models/teilnehmer";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Kurs } from './../_models/kurs';
//import { retry } from 'rxjs/operator/retry';

@Injectable()
export class TeilnehmerService
{

  constructor(private kservice: KursService, @Inject('BASE_URL') private baseUrl: string, private http: HttpClient)
  {
  }

  public GetTnByKurs(k: number): Observable<Kursteilnehmer[]>
  {
    var query = this.baseUrl + 'api/kursteilnehmer/GetKursteilnehmerByKurs/' + k;
    return this.http.get<Kursteilnehmer[]>(query);
  }
  public GetTn()
  {
    return this.http.get<Kursteilnehmer[]>(this.baseUrl + "api/kursteilnehmer");
  }
  public GetTnById(id: number)
  {
    return this.http.get<Kursteilnehmer>(this.baseUrl + "api/kursteilnehmer/" + id);
  }

  public GetStudentByName(searchString: string) {
    return this.http.get<Kursteilnehmer[]>(this.baseUrl + "api/kursteilnehmer/findKursteilnehmer/" + searchString);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/_services/teilnehmer.service.ts